import axios from './../axios';

export const signUp = async (payload) => {
  try {
    return await axios.post(`/sign-up`, payload);
  } catch (err) {
    return err.response;
  }
};
